// Pages
import TransactionList from './pages/TransactionList';
import TransactionReceipt from './pages/TransactionReceipt';

import LocationList from './pages/LocationList';
import LocationCreate from './pages/LocationCreate';
import LocationEdit from './pages/LocationEdit';

import SettingsAccount from './pages/SettingsAccount';
import SettingsSupport from './pages/SettingsSupport';
import SettingsLegal from './pages/SettingsLegal';

import SettingsTeam from './pages/SettingsTeam';
import SettingsTeamCreate from './pages/SettingsTeamCreate';
import SettingsTeamEdit from './pages/SettingsTeamEdit';


// Routes
export const appRoutes = [
  {
    name: 'admin',
    path: '/admin',
    forwardTo: 'receiver.admin.transactions',
    children: [
      {
        name: 'transactions',
        path: '/transactions?q&locationId',
        comp: TransactionList,
        children: [
          {
            name: 'receipt',
            path: '/receipt/:transactionId',
            comp: TransactionReceipt,
          }
        ],
      },
      {
        name: 'locations',
        path: '/locations?q',
        comp: LocationList,
        children: [
          {
            name: 'create',
            path: '/create',
            comp: LocationCreate,
          },
          {
            name: 'edit',
            path: '/edit/:locationId',
            comp: LocationEdit,
          },
        ],
      },
      {
        name: 'settings',
        path: '/settings',
        forwardTo: 'receiver.admin.settings.account',
        comp: SettingsAccount,
        children: [
          {
            name: 'account',
            path: '/account',
            comp: SettingsAccount,
          },
          {
            name: 'team',
            path: '/team',
            comp: SettingsTeam,
            children: [
              {
                name: 'create',
                path: '/create',
                comp: SettingsTeamCreate,
              },
              {
                name: 'edit',
                path: '/edit/:userId',
                comp: SettingsTeamEdit,
              },
            ],
          },
          {
            name: 'support',
            path: '/support',
            comp: SettingsSupport,
          },
          {
            // TODO
            name: 'legal',
            path: '/legal',
            comp: SettingsLegal,
          }
        ],
      },
    ],
  }
];
